import { Component, ElementRef, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { SocialLinks } from '../../core/models/social-links.model';
@Component({
  selector: 'app-social-links',
  templateUrl: './social-links.component.html',
  styleUrls: ['./social-links.component.sass']
})
export class SocialLinksComponent implements OnInit {

  facebookControl: FormControl;
  twitterControl: FormControl;
  instagramControl: FormControl;
  snapchatControl: FormControl;
  linkedinControl: FormControl;
  links: Array<SocialLinks>;

  @Output() userSocialLinks = new EventEmitter<SocialLinks>();
  @ViewChild('facebookInput', { static: true }) facebookInput: ElementRef<
    HTMLInputElement
  >;
  @ViewChild('twitterInput', { static: true }) twitterInput: ElementRef<
    HTMLInputElement
  >;

  constructor() { }

  ngOnInit(): void {
    this.facebookControl = new FormControl();
    this.twitterControl = new FormControl();
    this.instagramControl = new FormControl();
    this.snapchatControl = new FormControl();
    this.linkedinControl = new FormControl();
    this.links = [];
  }



  onFacebookPaste(event: ClipboardEvent) {
    let clipboardData = event.clipboardData;
    let pastedText = clipboardData.getData('text');
  }
  onTwitterPaste(event: ClipboardEvent) {
    let clipboardData = event.clipboardData;
    let pastedText = clipboardData.getData('text');
  }
  inputChangeFacebook(data) {
    console.log('FB ', this.facebookControl.value.includes('facebook.com'));
    if (this.facebookControl.value !== null && this.facebookControl.value.includes('facebook.com')) {
      // this.links.facebook = this.facebookControl.value;
      // this.userSocialLinks.emit(this.links);
    }
    console.log(this.facebookControl.value, ' ', this.links);

  }

  inputChangeTwitter(data) {
    console.log('TW ', this.twitterControl.value);
    if (this.twitterControl.value !== null && this.twitterControl.value.includes('twitter.com')) {
      // this.links.twitter, this.twitterControl.value;
      // this.userSocialLinks.emit(this.links);
    }
    console.log(this.twitterControl.value, ' ', this.links);
  }
  inputChangeInstagramUserName(data) {
    console.log('TW ', this.twitterControl.value);
    if (this.instagramControl.value !== null && this.instagramControl.value.includes('twitter.com')) {
      // this.links.instagram = this.instagramControl.value;
      // this.userSocialLinks.emit(this.links);
    }
    console.log(this.twitterControl.value, ' ', this.links);
  }
  inputChangeSnapchatUsername(data) {
    console.log('TW ', this.twitterControl.value);
    if (this.snapchatControl.value !== null && this.snapchatControl.value.includes('twitter.com')) {
      // this.links.snapchat = this.snapchatControl.value;
      // this.userSocialLinks.emit(this.links);
    }
    console.log(this.snapchatControl.value, ' ', this.links);
  }
  inputChangeLinkedIn(data) {
    console.log('TW ', this.twitterControl.value);
    if (this.linkedinControl.value !== null && this.linkedinControl.value.includes('twitter.com')) {
      // this.links.linkedin = this.linkedinControl.value;
      // this.userSocialLinks.emit(this.links);
    }
    console.log(this.linkedinControl.value, ' ', this.links);
  }
}
